export default __webpack_public_path__ + "static/media/genuine.6920ffb8.png";